<script>
import {mapGetters} from 'vuex'
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
	path:{
		type: String,
		default: ''
	}
  },
  render(h, context) {
    const { icon, title,path } = context.props;
    const vnodes = []
    if (icon) {
      if (icon.includes('el-icon')) {
		  if(path == '/im' && context.parent.$store.getters.unreadChatNum > 0 ){
			  vnodes.push(<i class={[icon, 'sub-el-icon notify-menuIcon']} />)
		  }else{
			  vnodes.push(<i class={[icon, 'sub-el-icon']} />)
		  }
        
      } else {
        vnodes.push(<svg-icon icon-class={icon}/>)
      }
    }

    if (title) {
		if(path == '/im'){
			vnodes.push(<el-badge value={context.parent.$store.getters.unreadChatNum} max={99} hidden={context.parent.$store.getters.unreadChatNum >0 ? false : true } slot='title'><span>{title}</span></el-badge>)
			
			// vnodes.push(<span slot='title'>{(title)}<span class={context.parent.$store.getters.unreadNum > 0 ? 'notify-menus show':'notify-menus '}>{context.parent.$store.getters.unreadNum}</span></span>)
		}else {
			vnodes.push(<span slot='title'>{(title)}</span>)
		}
      
    }
    return vnodes
  }
}
</script>

<style  lang="scss" scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}
	.notify-menus {
		width: 26px;
		height: 26px;
		background: #ff1e1e;
		display: none;
		border-radius: 50%;
		
		color: #fff;
		margin-left: 5px;
		font-size: 12px;
		font-weight: 500;
		line-height: 26px;
		text-align: center;
		box-sizing: border-box;
		&.show {
			display: inline-block;
		}
  }
  ::v-deep {
  	  .el-badge__content.is-fixed {
  	  	top: 20px;
  	  	right: -10px;
  	  }
  }
  .notify-menuIcon {
	  animation: notifymove 3s infinite;
	  animation-direction: alternate;
	  -webkit-animation: notifymove 3s infinite;
  }
  @keyframes notifymove {
    0% {
      color: #ff1e1e;
    }
  
    25% {
      color: #2e3238;
    }
  
    50% {
      color: #ff1e1e;
    }
  
    75% {
      color: #2e3238;
    }
  
    100% {
      color: #ff1e1e;
    }
  }
</style>
